import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './commerçant/page/Clients/components/clients/Toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ToastProvider>
    <App /></ToastProvider>
);

